export const GLOBAL = 0;
export const APP = 5;
export const COMPANY = 10;
export const COMPANY_APP = 11;
export const USER = 30;
export const COMPANY_USER = 31;
export const COMPANY_USER_APP = 32;

export default {
  GLOBAL,
  APP,
  COMPANY,
  COMPANY_APP,
  USER,
  COMPANY_USER,
  COMPANY_USER_APP
};
